import { FC } from 'react';

import { TableRowStyled } from './TableRow.styles';
import { TableRowProps } from './TableRow.types';

const TableRow: FC<TableRowProps> = (props) => {
  const { children, ...rest } = props;
  return <TableRowStyled {...rest}>{children}</TableRowStyled>;
};

export default TableRow;
